export default __webpack_public_path__ + "static/PC_1_1-506a82fcf1e8491c336be83984c65248.png";